module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textfield"
  }, [_vm._v("\n  " + _vm._s(_vm.data) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7eb8916"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldFactsheet.vue
// module id = 713
// module chunks = 0